import { render, staticRenderFns } from "./SupplierSales.vue?vue&type=template&id=55a99c66"
import script from "./SupplierSales.vue?vue&type=script&lang=js"
export * from "./SupplierSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports